<template>


<section id="new_ref_fourth_step" class="flex">

    <titlePage>
        <template slot="titleBody">
            <div class="hero-head has-text-centered" >
                <h1 class="title has-text-weight-light is-size-1 ">{{ currentRef.name }}</h1>
            </div>
        </template>
    </titlePage>

    <div class="subsection_container hero flex" >

        <div class="hero-body" >
            <div class="container mini-container has-text-centered">

                <div class="choose_ref_cat_container" v-if="!notOwnedRef">

                    <h2 class="title is-size-1 has-text-weight-bold stepTitle">{{ $t('modules.refs.formStep2.title') }}</h2>

                    <RefSelectByCat :isCustom="false" :selectedCatId="selectedCatId" :selectedRefId="selectedRefId" @SelectChanged="setRefValues" />

                    <btn-circle-icon v-if="isNew" v-bind:class="{disabled: !isFormValid}" class="large" icon="icon-arrow-right" @click.native="nextStep" />

                </div>
                <div class="choose_ref_cat_container" v-else>
                    <h2 class="title is-size-1 has-text-weight-bold stepTitle">{{ $t('modules.refs.formStep3.associatedRef') }} :<br> {{ currentRef.associated_ref.name }}</h2>
                </div>
            </div>
        </div>
    </div>


</section>

</template>

<script>
import titlePage from "@/components/layouts/titlePage"

export default {
    name: 'FormStep2',
    props: ['isNew', "notOwnedRef"],
    components: {
        titlePage
    },
    data(){
        return {
            selectedCat: {}

        }
    },
    computed: {
        currentRef(){
            return this.$store.state.RefStore.currentRef
        },
        selectedRefId(){
            return this.currentRef.associated_ref_id
        },
        selectedCatId(){
            if (this.currentRef.associated_ref){
                return this.currentRef.associated_ref.sight_ref_cat_id
            }else{
                return null
            }
        },
        isFormValid(){
            return (this.selectedRefId) ? true : false
        }
    },
    methods: {
        setRefValues(selectedCatId, selectedRefId, selectedRef, selectedCat){
            if(selectedRefId){
                this.$store.commit('RefStore/updateRefData', { associated_ref: selectedRef, associated_ref_id: selectedRefId } )
            }else{
                this.$store.commit('RefStore/updateRefData', { associated_ref: { sight_ref_cat_id:  selectedCatId}, associated_ref_id: null } )
            }
            this.$store.commit('RefStore/updateFormValidity', { index: 1, validity: this.isFormValid } )
        },
        nextStep(){
            if(this.isFormValid){
                this.$store.commit('RefStore/changeCurrentStep', { index: 2 })
            }
        }
    }
}

</script>

<style lang="scss" scoped>
    #new_ref_fourth_step{
        background: $white;
        display: flex;
        flex-direction: column;
        .subsection_container{
            .hero-body{
                display: flex;
                align-items: center;
                justify-content: center;
                margin-bottom: 100px;
            }
        }
    }


</style>